import navsync from "../../../../assets/images/blogs/pp10/navsync.mp4";
import * as React from 'react';
export default {
  navsync,
  React
};